<div class="wrapper" [ngClass]="{'checkout-item': _variant === VARIANT_CHECKOUT_ITEM, 'cart-item': _variant === VARIANT_CART_ITEM}">
  @if (loading) {
    <app-spinner></app-spinner>
  }
  @if (!loading) {
    <div class="container">
      <div class="item-contents flex">
        <div>
          @if (subscription.membershipLevel === 'Gold') {
            <div class="gold gold-membership gold-background">
              <div class="wwm-icon"></div>
              Gold
            </div>
          }
          @if (subscription.membershipLevel === 'Platinum') {
            <div class="platinum platinum-membership platinum-background">
              <div class="wwm-icon"></div>
              Platinum
            </div>
          }
        </div>
        <div class="item-details">
          <p class="title">{{subscription.membershipLevel}} Membership</p>
          <p>Recurs each year at $125/yr, good for up to $200 of discounts</p>
          <div class="edit-details">
            <a class="edit" (click)="openConfirmationModal()">Remove</a>
          </div>
        </div>
        <div class="cart-price">
          @if (isDiscounted) {
            <div class="previous-price"><s>{{plan.price | currency:'USD'}}</s></div>
          }
          <p class="total-amount ml-10">{{subscription.paymentAmount | currency:'USD'}}</p>
          @if (isDiscounted) {
            <div class="discount-percent">{{discountPercent}}% Discount Applied</div>
          }
        </div>
      </div>
      <div class="button regular close" (click)="openConfirmationModal()"><span class="icon">&#x00D7;</span></div>
    </div>
  }
</div>
<app-confirm-modal
  [modalId]="modalId"
  [text]="confirmText"
  [buttonText]="buttonText"
  (confirmChoice)="onItemRemove($event)"
></app-confirm-modal>
<app-error-modal [modalId]="'cart-item-error-modal'" [text]="errorText"></app-error-modal>
